import { Controller } from '@hotwired/stimulus';

// Remembers that a banner was dismissed, so it stays gone past this page. Pair it with
// Ui::BannerComponent, which owns the dismiss animation and announces when it finishes.
export default class extends Controller {
  static values = { dismissUrl: String };

  dismissed() {
    if (!this.hasDismissUrlValue || !this.dismissUrlValue) return;

    const meta = document.querySelector('meta[name="csrf-token"]');

    fetch(this.dismissUrlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': (meta && meta.content) || '',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).catch(() => {
      // The banner is already gone from this page; the worst case is it returns on the next load.
    });
  }
}
